import { render, staticRenderFns } from "./chuanpiaoList.vue?vue&type=template&id=4c9ccd34&scoped=true&"
import script from "./chuanpiaoList.vue?vue&type=script&lang=js&"
export * from "./chuanpiaoList.vue?vue&type=script&lang=js&"
import style0 from "./chuanpiaoList.vue?vue&type=style&index=0&id=4c9ccd34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9ccd34",
  null
  
)

export default component.exports